module.exports = __webpack_public_path__ + "img/doujiang.7d9c54ef.png";